<template>
  <footer class="app-footer">
    <img src='static\img\logo.png' height="40px" width="100px">
    <a href="http://bcbatam.beacukai.go.id/">KPU BC Batam</a> &copy; 2022. Versi 2.1.2
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?76ddde17